<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-snackbar
      :style="{ marginTop: snack_height + 'px' }"
      v-model="tbsnackbar"
      :top="true"
      color="error"
    >
      <span class="tab-msg">Tab Switching Not Allowed!!</span>
      <v-btn class="tab-msg" dark text @click="tbsnackbar = false">Close</v-btn>
    </v-snackbar>

        <!-- <v-snackbar
      :style="{ marginTop: snack_height + 'px' }"
      v-model="tb"
      color="success"
    >
      <span class="tab-msg">Are you sure!!!</span>

      <v-btn class="tab-msg" dark text @click="yes">Yes</v-btn>
      <v-btn class="tab-msg" dark text @click="no">No</v-btn>

    </v-snackbar> -->
<v-dialog
        transition="dialog-top-transition"
        max-width="400"
        v-model="tb"
      >

        <template >
          <v-card>
            <!-- <v-toolbar
              color="primary"
              dark
            >Opening from the top</v-toolbar> -->
            <v-card-text>
              <center>
              <div class="text-h2 pa-12" style="font-weight:bold;font-size:20px;color:red">Are you sure!!!</div>
              <v-row class="justify-center">
                <v-btn style="margin:10px;"  color="error" @click="yes">YES</v-btn>
                <v-btn  style="margin:10px;" color="success" @click="no">NO</v-btn>

              </v-row>
              </center>
            </v-card-text>
        
          </v-card>
        </template>
      </v-dialog>






    <div @click="chat" class="chat-icon" v-if="les !== null">
      <div v-if="chatIcon">
        <i
          class="mdi mdi-wechat"
          style="color: hsla(190, 99%, 30%, 1); font-size: 100px"
        ></i>
      </div>
      <div v-if="chatFlag">
        <studchat :chat_data="chat_data"></studchat>
      </div>
    </div>

    <!-- <div class="chat-icon">
            <div v-if="calFlag">
                <studCalculator></studCalculator>
            </div>
        </div> -->

    <div class="main-h">
      <div class="mt-4">
        <router-link
          :to="'/role-links/student/start-exam'"
          style="text-decoration: none"
          class="root"
        >
          <v-icon left class="home-icon">mdi-keyboard-backspace</v-icon>
          <span class="home-text">Home</span>
        </router-link>
      </div>

      <template v-if="deviceWidth > 600">
        <!-- <div class="mt-4 borderes">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon left color="white" class="mdi mdi-calculator" @click="calculator" v-bind="attrs" v-on="on"> mdi mdi-calculator </v-icon>
                        </template>
                        <span>Calculator</span>
                    </v-tooltip>
                </div> -->

        <div class="mt-4 borderes">
          <v-icon
            left
            class="mdi mdi-file-table"
            color="white"
            @click="logs = !logs"
            >mdi mdi-file-table</v-icon
          >
          <span @click="logs = !logs">Log Table</span>
        </div>
        <!-- 111{{show_whitebord}} -->
        <div class="mt-4 borderes" v-if="show_whitebord == true">
          <a
            href="https://jamboard.google.com/"
            target="popup"
            class="whiteboard"
            onclick="window.open('https://jamboard.google.com/','popup','width=600,height=600,scrollbars=no,resizable=no'); return false;"
          >
            White Board
          </a>
        </div>

        <div class="mt-4 borderes">
          <v-icon left color="#ff9800">mdi-book-open-page-variant</v-icon>
          <span>{{ current_ques.course_obj.course_name }}</span>
        </div>
        <div class="mt-4 borderes">
          <v-icon
            left
            class="mdi mdi-file-table"
            color="white"
            @click="ISA_table = !ISA_table"
            >mdi mdi-file-table</v-icon
          >
          <span @click="ISA_table = !ISA_table">ISE Table</span>
        </div>

        <div class="mt-4" style="display: flex">
          <div class="timer">
            <v-icon color="red" left>mdi-timer-sand</v-icon> {{ show_time }}
          </div>
          <div>
            <v-btn rounded small @click="exitExam('ask')" class="end-exam">
              <v-icon left>mdi-stop-circle-outline</v-icon> End Exam
            </v-btn>
          </div>
        </div>
      </template>
    </div>
    <!-- <div class="timer mt-4">
            <v-icon color="white" left>mdi-timer-sand</v-icon> {{show_time}}
        </div>
        <div class="mt-3">
            <v-btn large color="error" @click="exitExam('ask')">
                <v-icon left>mdi-stop-circle-outline</v-icon> End Exam
            </v-btn>
        </div> -->
    <!-- <div style="display:flex;justify-content:flex-end;" class="pt">
        <div>
            <v-btn rounded class="ma-2" style="color:white" color="green">
                <v-icon>mdi-calendar-clock</v-icon>
                &nbsp;&nbsp; &nbsp;&nbsp; {{les.starttime}}
            </v-btn>To
            <v-btn rounded class="ma-2" style="color:white" color="error">
                <v-icon>mdi-calendar-clock</v-icon>
                &nbsp;&nbsp; &nbsp;&nbsp;{{les.endtime}}
            </v-btn>
        </div>
    </div> -->
    <br />
    <br />
    <br />
    <!-- <div id="mobile-view"></div> -->
    <template v-if="deviceWidth < 600">
      <div class="mt-4 timer-m">
        <div class="timer">
          <v-icon color="red" left>mdi-timer-sand</v-icon> {{ show_time }}
        </div>
        <div>
          <v-btn rounded small @click="exitExam('ask')" class="end-exam">
            <v-icon left>mdi-stop-circle-outline</v-icon> End Exam
          </v-btn>
        </div>
      </div>
      <v-row class="justify-center">
        <div class="mt-4 borderes">
          <!-- <v-icon left class="home-icon" @click="logs=!logs">mdi mdi-file</v-icon> -->
          <!-- <span @click="logs=!logs">
                        <v-icon left class="mdi mdi-file-table">mdi-file-table</v-icon>
                    </span> -->
          Log<v-icon
            left
            color="black"
            class="mdi mdi-file-table pl-3"
            @click="logs = !logs"
          >
            mdi mdi-file-table
          </v-icon>
          |
        </div>

        <div class="mt-4 borderes">
          <v-icon left color="#ff9800" class="pl-2"
            >mdi-book-open-page-variant</v-icon
          >
          <span>{{ current_ques.course_obj.course_name }}</span>
        </div>
        <!-- <div class="mt-4 borderes">
                        <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon left color="black" class="mdi mdi-calculator pl-3" @click="calculator"  v-bind="attrs" v-on="on"> mdi mdi-calculator </v-icon>
                        </template>
                        <span>Calculator</span>
                    </v-tooltip>
                </div> -->

        <div class="mt-4 borderes">
          |<span class="pl-4">ISE</span
          ><v-icon
            left
            color="black"
            class="mdi mdi-file-table pl-2"
            @click="ISA_table = !ISA_table"
            v-bind="attrs"
            v-on="on"
          >
            mdi mdi-file-table
          </v-icon>
        </div>
      </v-row>
    </template>
    <template v-if="stud_ques_ans_list != null">
      <v-row class="row-card">
        <v-col xs="12" sm="12" lg="9" xl="9" md="12" cols="12">
          <v-card
            class="card-ques"
            id="style-3"
            :style="{ height: deviceHeight + 'px' }"
          >
            <!-- <div class="que-display">
              <span class="que-tag"
                >Question - {{ que_index + 1 }}/{{
                  stud_ques_ans_list.length
                }}</span>
              <span class="time que-tag"
                >[ {{ current_ques.question_weightage }} marks ]</span
              >
              
            </div> -->
<div class="d-f que-display ">
<div>              <span class="que-tag"
                >Question - {{ que_index + 1 }}/{{
                  stud_ques_ans_list.length
                }}</span></div>
<div class="invlid-q" v-if="invalidQuestionCheck"><span> <v-checkbox dense
@change="markInvalid"
      v-model="current_ques.isInvalid"
      label="Invalid Question" 
    ></v-checkbox></span></div>
<div>              <span class="time que-tag"
                >[ {{ current_ques.question_weightage }} marks ]</span
              ></div>
</div>




            <div class="que">
              <!-- Question for all type -->
              <div class="question-block">
                <span
                  class="question-text"
                  v-html="current_ques.question_obj.question"
                ></span>
                <span v-if="current_ques.question_image != null">
                  <img
                    class="imgs-question"
                    :src="current_ques.question_image"
                    v-if="current_ques.question_image != null"
                    @click="zooimg(current_ques.question_image)"
                  />
                  <!-- <img :src="current_ques.question_image" v-if="current_ques.question_image!=null" class="q-img" /> -->
                </span>
              </div>
              <!-- Question for all type ends-->
              <!-- MCQ -->
              <template v-if="current_ques.questiontype == 'MCQ'">
                <b class="options-text">Options</b>
                <v-card-text class="padding-options">
                  <br />
                  <div v-for="opt in current_ques.options" :key="opt.id">
                    <div class="row padding-zero">
                      <div
                        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 padding-top-zero"
                      >
                        <div class="row padding-zero">
                          <div class="opt" @click="check(opt.option_name)">
                            <div class="opt-label">{{ opt.option_name }}</div>
                          </div>
                          <div class="opt-radio">
                            <div class="opt-label">
                              <input
                                type="radio"
                                :id="opt.option_name"
                                @click="select_opt = opt"
                                v-if="current_ques.selectedoption_obj != null"
                                :name="current_ques.id"
                                :checked="
                                  current_ques.selectedoption_obj.id == opt.id
                                "
                              />
                              <input
                                type="radio"
                                :id="opt.option_name"
                                @click="select_opt = opt"
                                v-else
                                :name="current_ques.id"
                              />
                            </div>
                          </div>
                          <span
                            class="option-val"
                            v-html="opt.option_value"
                          ></span>
                          <!-- <img class="imgs-options" :src="opt.option_file" v-if="opt.option_file!=null" @click="zooimg(opt.option_file)" /> -->
                          <!-- <img :src="opt.option_file" v-if="opt.option_file!=null" class="ans-img" /> -->
                        </div>
                        <div>
                          <img
                            class="imgs-options"
                            :src="opt.option_file"
                            v-if="opt.option_file != null"
                            @click="zooimg(opt.option_file)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </v-card-text>
                <br />
              </template>
              <template v-if="current_ques.questiontype == 'Subjective'">
                <!-- {{current_ques}} -->
                <!-- {{current_ques}} -->
                <v-card-text class="padding-options">
                  <v-textarea
                    placeholder="Enter your answers here"
                    persistent-hint
                    outlined
                    v-model="current_ques.answer_text"
                  ></v-textarea>
                  <div
                    v-for="(file, index) in current_ques.sub_file_list"
                    :key="index"
                  >
                  <v-row class="ml-2" style="margin-bottom:10px" >
                      <span style="color:red;font-size:25px;margin-right:12px" class="mdi mdi-delete-circle" @click="deleteFile(file)" :loading="save_load_btn"></span>
   <a :href="file.ans_file" target="_blank"
                      >F#{{ index + 1 }}</a
                    >
                        <!-- <v-btn color="error" @click="deleteFile(file)" :loading="save_load_btn">Delete</v-btn> -->

                  </v-row>
                 
                    <!-- <v-btn @click="deleteFile(file)" :loading="save_load_btn">Delete</v-btn> -->
                  </div>
                  <v-row>
                  <v-col cols="6">

   <v-file-input
                  outlined
                    multiple
                    label="File input"
                    dense
                    v-model="current_ques.sub_file_upload"
                    accept=".*"
                    :hint="current_ques.sub_file != null ? '' : 'Please Select File'"
                    persistent-hint
                    show-size
                    prepend-icon="mdi-paperclip"
                  ></v-file-input>
                  </v-col>
                        <!-- <v-btn style="margin: 1rem;" color="error" @click="deleteFile(file)" :loading="save_load_btn">Delete</v-btn> -->
                  </v-row>

               
                </v-card-text>
              </template>
              <!-- Subject -->
            </div>
          </v-card>
          <div class="nav-btn">
            <v-btn
              class="sub-btn next-btn"
              rounded
              :loading="save_load_btn"
              @click="getPrevious"
              v-if="que_index !== 0"
              >Previous</v-btn
            >
            <v-btn
              :loading="save_load_btn"
              rounded
              class="sub-btn save-btn"
              @click="saveAnswer('ANSWERED')"
              >Save</v-btn
            >&nbsp;&nbsp;
            <v-btn
              :loading="save_load_btn"
              rounded
              class="sub-btn review-btn"
              @click="saveAnswer('REVIEW')"
              >Save & Review</v-btn
            >&nbsp;&nbsp;
            <v-btn
              class="sub-btn next-btn"
              rounded
              :loading="save_load_btn"
              @click="getNext"
              v-if="!(que_index == stud_ques_ans_list.length - 1)"
              >Next</v-btn
            >
            
          </div>
        </v-col>
        <v-col
          xs="12"
          sm="12"
          lg="3"
          xl="3"
          md="12"
          cols="12"
          class="overview-row"
        >
          <v-card
            class="overview-card"
            :style="{ height: deviceHeight + 'px' }"
          >
            <div class="que-display">
              <span class="que-tag">Questions Overview</span>
            </div>
            <v-card-text align="center">
              <!-- <v-btn
                                :loading="save_load_btn"
                                rounded
                                @click="getQues(ques,index)"
                                :style="{'background-color':ques.studentansweredstatus_obj.color,'opacity':que_index==index?'1.0':'0.5','margin':'3px','color':'white'}"
                                v-for="(ques,index) in stud_ques_ans_list"
                                :key="ques.id"
                            >
                                {{index+1}}
                            </v-btn> -->
              <v-btn
                :loading="save_load_btn"
                rounded
                @click="getQues(ques, index)"
                :style="{
                  'background-color': ques.studentansweredstatus_obj.color,
                  margin: '3px',
                  color: 'white',
                  'font-size': que_index !== index ? '' : '20px',
                  border: que_index !== index ? 'none' : '3px solid black',
                  color: que_index !== index ? 'white' : 'black',
                }"
                v-for="(ques, index) in stud_ques_ans_list"
                :key="ques.id"
              >
                {{ index + 1 }}
              </v-btn>
              &nbsp;
            </v-card-text>
            <!-- <v-card-text>
                                <span v-for="status in ans_status" :key="status.id">
                                        <v-col xs="12" sm="12" lg="12" xl="12" md="12" cols="12" class="padding text-center">
                                            <v-btn  :color="status.color"  class="stu-btn">{{status.name}} </v-btn>
                                        </v-col>
                                </span>
                    </v-card-text> -->
            <div style="margin-left: 2rem">
              <v-card-text
                v-for="status in ans_status"
                :key="status.id"
                class="padding-zero"
                style="display: flex; margin-left: 20px"
              >
                <div
                  class="status"
                  :style="{ 'background-color': status.color }"
                ></div>
                <div>
                  <div style="padding: 8px; font-weight: bold">
                    {{ status.name }}
                  </div>
                </div>
              </v-card-text>
              <!-- {{supervisionlink}} -->
            </div>

            <!-- <v-row style="margin:0px;padding:0px;">
                        <span v-for="status in ans_status" :key="status.id">
                            <v-col xs="12" sm="12" lg="12" xl="12" md="12" cols="12">
                             <v-btn  :color="status.color" rounded class="stu-btn">{{status.name}} </v-btn>
                             </v-col>
                        </span>
                    </v-row> -->
          </v-card>
          <div class="meet-box" v-if="supervisionlink.supervisionlink">
            <v-row class="pl-3"
              ><span style="font-weight: bold">Meeting Link:</span></v-row
            >
            <a target="_blank" :href="supervisionlink.supervisionlink">{{
              supervisionlink.supervisionlink
            }}</a>
          </div>
        </v-col>
      </v-row>
      <!-- </div> -->
    </template>

    <template>
      <div class="text-center">
        <v-dialog v-model="dialog" width="500">
          <v-card>
            <v-card-text
              style="
                text-align: center;
                padding: 20px;
                color: red;
                font-size: 16px;
              "
              >{{ msg }}</v-card-text
            >
            <v-card-actions style="justify-content: center">
              <v-btn class="button" @click="dialog = false">OK</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>

    <template>
      <div class="text-center">
        <v-dialog v-model="meetingBox" persistent width="500">
          <v-card class="meet">
            <v-card-text
              style="
                text-align: center;
                padding: 20px;
                color: red;
                font-size: 16px;
              "
            >
              <span
                ><h3 class="blink_me">
                  Please join meeting immediately!!
                </h3></span
              >
            </v-card-text>
            <v-card-text
              v-if="supervisionlink.meetingid"
              style="text-align: center"
              >Meeting Id : {{ supervisionlink.meetingid }}</v-card-text
            >
            <v-card-text
              v-if="supervisionlink.meetingpassword"
              style="text-align: center"
              >Meeting Password :
              {{ supervisionlink.meetingpassword }}</v-card-text
            >
            <v-card-text style="text-align: center">
              <span>Click on below Meeting Link</span>
              <v-card-text>
                <a
                  target="_blank"
                  @click="meeting"
                  :href="supervisionlink.supervisionlink"
                  >{{ supervisionlink.supervisionlink }}</a
                >
              </v-card-text>
            </v-card-text>

            <!-- <v-card-actions style="justify-content: center;">
                            <v-btn class="button" @click="meetingBoxClose">CLOSE</v-btn>
                        </v-card-actions> -->
          </v-card>
        </v-dialog>
      </div>
    </template>

    <!-- <br />
         <v-btn v-for="status in ans_status" :key="status.id" :color="status.color">{{status.name}}yyy</v-btn>
    {{image capture component}}-->
    <image-capture />
    <weired-sound />
    <v-row justify="center">
      <v-dialog v-model="dialog_zooimg" persistent max-width="800px">
        <v-card>
          <br />
          <v-card-title>
            <span class="headline">Image Pre-View</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <img
                    class="question-img rounded w-100 d-block imgs-preview"
                    :src="img_url"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" rounded @click="dialog_zooimg = false"
              >Close</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <template>
      <div class="text-center">
        <v-dialog v-model="logs" :width="logWidth">
          <v-card>
            <v-card-text class="log-t">
              <div class="log-flex">
                <div>Logarithm Table</div>
                <div>
                  <i
                    style="font-weight: 20px"
                    @click="logTable"
                    class="mdi mdi-close-box"
                  ></i>
                </div>
              </div>
            </v-card-text>
            <!-- <embed src="https://wikieducator.org/images/4/41/Logrithm_Table.pdf" width="1000px" :height="deviceHeight" /> -->
            <!-- <object data="https://wikieducator.org/images/4/41/Logrithm_Table.pdf" width="1000px" type="application/pdf" :height="deviceHeight"></object> -->
            <div class="pdf-block">
              <studlogtable ref="pdfComponent"></studlogtable>
            </div>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="logs = false"> close </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>

    <template>
      <div class="text-center">
        <v-dialog v-model="ISA_table" :width="logWidth">
          <v-card>
            <v-card-text class="log-t">
              <div class="log-flex">
                <div>ISE Table</div>
                <div>
                  <i
                    style="font-weight: 20px"
                    @click="ISA_table = !ISA_table"
                    class="mdi mdi-close-box"
                  ></i>
                </div>
              </div>
            </v-card-text>
            <div class="pdf-block">
              <studISAtable ref="pdfISAComponent"></studISAtable>
            </div>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="ISA_table = false">
                close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </div>
</template>

<script>
import "@/assets/css/color.css";
import axios from "axios";
import { VueMathjax } from "vue-mathjax";
import MathLive from "mathlive";
import ImageCapture from "./PhotoCapture";
import WeiredSound from "./WeiredSound";
import studchat from "./StudChat";
import studlogtable from "./StudLogtable";
import studISAtable from "./StudISAtable";

// import studCalculator from "./StudCalculator";

export default {
  components: {
    "vue-mathjax": VueMathjax,
    "image-capture": ImageCapture,
    "weired-sound": WeiredSound,
    studchat: studchat,
    studlogtable: studlogtable,
    studISAtable: studISAtable,
    // studCalculator: studCalculator,
  },
  data: () => ({
    tb:false,
    endexamflag_new:false,
    TAB_SWITCHING:null,
    // calFlag: false,
    logs: false,
    ISA_table: false,
    deviceWidth: "",
    msg1: "Nothing..",
    chatIcon: true,
    chatFlag: false,
    meetingLink: "",
    meetingBox: false,
    deviceHeight: "",
    tbsnackbar: false,
    tabSwitchCount:0,
    endexamflag: false,
    supervisionlink: null,
    timeout: 0,
    msg: "",
    dialog: false,
    img_url: "",
    dialog_zooimg: false,
    snackbar_msg: "",
    snackbar: false,
    color: "",
    org: null,
    twominute: true,
    snack_height: "",
    //
    stud_ques_ans_list: null,
    current_ques: null,
    les: null,
    ans_status: null,
    name: "Timer",
    select_opt: null,
    que_index: 0,
    checkbox:null,
    //
    save_load_btn: false,

    //NDV Changes
    totalsec: 0,
    show_time: "",
    tim: null,
    chat_data: null,
    flag: false,
    logWidth: "",
    show_whitebord: false,
    invalidQuestionCheck: null,
    isBlurred:false
  }),
  updated: function () {
    // console.log("Inside updated");
    this.$nextTick().then(() => {
      if (window.MathJax) {
        // console.log("rendering mathjax");
        window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () =>
          console.log("done")
        );
      }
    });
  },

  watch:{
tabSwitchCount(){
  const data = {
    les_id: this.les.les_id,
  }
  if(this.TAB_SWITCHING == 'NO'){
      axios
        .post("/student/updateTabSwitch", data)
        .then((res) => {
          if (res.data.status == "YES") {
            //4CAF50
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
  }

}
  },
  methods: {
// checkTabSwitchcount(){
//   const data = {
//     les_id: this.les.les_id,
//   }
//       axios
//         .post("/student/checkTabSwitchcount", data)
//         .then((res) => {
//           if (res.data.status == "YES") {
//             //4CAF50
//           }
//         })
//         .catch((error) => {
//           this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
//         })
//         .finally(() => {});
// },
yes(){
this.tb = false
this.endexamflag_new = true
      var all_ques = [];
      for (var i = 0; i < this.stud_ques_ans_list.length; i++) {
        all_ques.push(this.stud_ques_ans_list[i].id);
      }
      const formData = {
        les_id: this.les.les_id,
        all_ques: all_ques,
      };
if(this.endexamflag_new){
      axios
        .post("/student/endExam", formData)
        .then((res) => {
          if (res.data.status == "YES") {
            //4CAF50
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
      localStorage.setItem("summury_id", this.les.les_id);
      localStorage.setItem("stud_ques_ans_list", "");
      localStorage.setItem("les", "");
      localStorage.setItem("ans_status", "");
      this.twominute = false;
      this.flag = JSON.parse(localStorage.getItem("show-result"));
      //window.alert(this.flag)
      if (this.flag == true) {
        this.$router.push({
          name: "show-result",
        });
      } else {
        this.$router.push({
          name: "stud-end-exam",
        });
      }
}
},
   no(){
this.tb = false
this.endexamflag_new = false
}, 

tabSwitchPermission(){

      axios
        .get("/student/tabSwitchPermission")
        .then((res) => {
          if (res.data.msg == "200") {
                        this.TAB_SWITCHING = res.data.TAB_SWITCHING
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});

},
    deleteFile(file) {
      console.log("file", file);
        var all_ques = [];
      for (var i = 0; i < this.stud_ques_ans_list.length; i++) {
        all_ques.push(this.stud_ques_ans_list[i].id);
      }

      const formData = {
        les_id: this.les.les_id,
        curr_qas_id: this.current_ques.id,
        safid:file.ans_file_id,
        all_ques: all_ques,
        supervisionlinkclick: this.supervisionlink.isClicked,
      };
      this.save_load_btn = true;
      axios
        .post("/student/delSubjFile", formData)
        .then((res) => {
          if (res.data.status == "YES") {
            this.answerResponse(res);
          } else {
            this.dialog = true;
            this.msg = res.data.snackbar;
            // this.showSnackbar("#b71c1c", res.data.snackbar);
            if (res.data.snackbar == "Time out") {
              this.exitExam("");
            }
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {
          this.save_load_btn = false;
        });
    },
    markInvalid(){

            const formData = {
        les_id: this.les.les_id,
        curr_qas_id: this.current_ques.id,
        selected_opt: this.select_opt,
        isInvalid:this.current_ques.isInvalid,
        // all_ques: all_ques,
        supervisionlinkclick: this.supervisionlink.isClicked,
      };
         axios
                    .post("/Student/markInvalidQue",formData)
                    .then((res) => {
                        if (res.data.status == "YES") {    
                          this.answerResponse(res);
                        } else {
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        window.console.log(error);
                    });
    },
    logTable() {
      this.logs = !this.logs;
      this.$refs.pdfComponent.onload();
    },
    // calculator() {
    //     this.calFlag = !this.calFlag;
    // },
    chat() {
      this.chatFlag = true;
      this.chatIcon = false;
    },
    meetingBoxClose() {
      // this.supervisionlink.isClicked = true;
      this.meetingBox = false;
      // localStorage.setItem("supervisionlink", JSON.stringify(this.supervisionlink));
    },
    meeting() {
      this.supervisionlink.isClicked = true;
      this.meetingBox = false;
      localStorage.setItem(
        "supervisionlink",
        JSON.stringify(this.supervisionlink)
      );
    },
    check(opt) {
      document.querySelector("#" + opt).click();
    },
    home() {
      this.$router.push({
        name: "role-links",
      });
    },
    sformat(s) {
      var fm = [
        // Math.floor(Math.floor(Math.floor(s / 60) / 60) / 24) % 24, //DAYS
        Math.floor(Math.floor(s / 60) / 60) % 60, //HOURS
        Math.floor(s / 60) % 60, //MINUTES
        s % 60, //SECONDS
      ];
      return $.map(fm, function (v, i) {
        return (v < 10 ? "0" : "") + v;
      }).join(":");
    },
    showtime() {
      //console.log("showtime");
      // 1 seconde eraf
      this.totalsec--;
      this.show_time = this.sformat(this.totalsec);
      if (this.totalsec == 0) {
        clearInterval(this.tim);
        //console.log("Exam ended...")
        this.exitExam("");
      }
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    getQues(ques, index) {
      this.current_ques = ques;
      this.que_index = index;
      this.select_opt = this.current_ques.selectedoption_obj;
    },
    saveAnswer(type) {
      console.log("this.current_ques", this.current_ques);
      if (this.current_ques.questiontype == "MCQ") {
        this.saveOption(type);
      } else if (this.current_ques.questiontype == "Subjective") {
        this.saveSubj(type);
      }
    },
    saveSubj(type) {
      if (this.current_ques.answer_text != null ||this.current_ques.sub_file_upload.length != 0) {
        var all_ques = [];
        for (var i = 0; i < this.stud_ques_ans_list.length; i++) {
            all_ques.push(this.stud_ques_ans_list[i].id);
         }
        let formData = new FormData();
        for (var i = 0; i < this.current_ques.sub_file_upload.length; i++) {
          let file = this.current_ques.sub_file_upload[i];
          formData.append("files", file);
        }
        formData.append("les_id",this.les.les_id)
        formData.append("curr_qas_id",this.current_ques.id)
        formData.append("subj_ans",this.current_ques.answer_text)
        formData.append("type",type)
        formData.append("all_ques[]",all_ques)
        formData.append("supervisionlinkclick",this.supervisionlink.isClicked)
    
      this.save_load_btn = true;
      axios
        .post("/student/saveSubj", formData)
        .then((res) => {
          if (res.data.status == "YES") {
            this.answerResponse(res);
             if (this.que_index + 1 < this.stud_ques_ans_list.length) this.getNext();
          } else {
            this.dialog = true;
            this.msg = res.data.snackbar;
            // this.showSnackbar("#b71c1c", res.data.snackbar);
            if (res.data.snackbar == "Time out") {
              this.exitExam("");
            }
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {
          this.save_load_btn = false;
        });
      } else {
        this.showSnackbar("#b71c1c", "Please enter answer or upload file!!!");
        return;
      }
    },
    answerResponse(res) {
      console.log('res------',res);
      this.les = res.data.les;
      this.current_ques = res.data.current_ques;
      this.select_opt = this.current_ques.selectedoption_obj;
      Object.assign(this.stud_ques_ans_list[this.que_index], this.current_ques);
      if (!this.supervisionlink.isClicked) {
        this.supervisionlink = res.data.supervisionlink;
      }
      localStorage.setItem(
        "stud_ques_ans_list",
        JSON.stringify(this.stud_ques_ans_list)
      );
      localStorage.setItem("les", JSON.stringify(this.les));
      if (this.les.end_timer != null) {
        this.totalsec = this.les.end_timer;
      }
      this.showSnackbar("#4CAF50", res.data.snackbar);
      // this.showSnackbar("#4CAF50",'File deleted Successfully!!');
     

      if (this.supervisionlink.isEnable && !this.supervisionlink.isClicked) {
        this.meetingBox = true;
      }
    },
    saveOption(type) {
      // console.log(this.select_opt.id)
      if (this.select_opt == null) {
        this.showSnackbar("#b71c1c", "Please select option.");
        return;
      }
      if (typeof this.select_opt.id === "undefined") {
        this.showSnackbar("#b71c1c", "Please select option.");
        return;
      }
      var all_ques = [];
      for (var i = 0; i < this.stud_ques_ans_list.length; i++) {
        all_ques.push(this.stud_ques_ans_list[i].id);
      }

      const formData = {
        les_id: this.les.les_id,
        curr_qas_id: this.current_ques.id,
        selected_opt: this.select_opt,
        type: type,
        all_ques: all_ques,
        supervisionlinkclick: this.supervisionlink.isClicked,
      };
      this.save_load_btn = true;
      axios
        .post("/student/saveOption", formData)
        .then((res) => {
          if (res.data.status == "YES") {
            this.answerResponse(res);
             if (this.que_index + 1 < this.stud_ques_ans_list.length) this.getNext();
          } else {
            this.dialog = true;
            this.msg = res.data.snackbar;
            // this.showSnackbar("#b71c1c", res.data.snackbar);
            if (res.data.snackbar == "Time out") {
              this.exitExam("");
            }
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {
          this.save_load_btn = false;
        });
    },
    exitExam(check) {
      // this.dialog = true;
this.tb = true
      // if (check == "ask") {
      //   if (!confirm("Are you sure!!!")) {
      //     this.endexamflag = true;
      //     return;
      //   }
      // }


//       var all_ques = [];
//       for (var i = 0; i < this.stud_ques_ans_list.length; i++) {
//         all_ques.push(this.stud_ques_ans_list[i].id);
//       }
//       const formData = {
//         les_id: this.les.les_id,
//         all_ques: all_ques,
//       };

// if(this.endexamflag_new){
//       axios
//         .post("/student/endExam", formData)
//         .then((res) => {
//           if (res.data.status == "YES") {
//           }
//         })
//         .catch((error) => {
//           this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
//         })
//         .finally(() => {});
//       localStorage.setItem("summury_id", this.les.les_id);
//       localStorage.setItem("stud_ques_ans_list", "");
//       localStorage.setItem("les", "");
//       localStorage.setItem("ans_status", "");
//       this.twominute = false;
//       this.flag = JSON.parse(localStorage.getItem("show-result"));
//       if (this.flag == true) {
//         this.$router.push({
//           name: "show-result",
//         });
//       } else {
//         this.$router.push({
//           name: "stud-end-exam",
//         });
//       }
// }

    },
    getNext() {
      // this.que_index = this.que_index+1
      this.current_ques = this.stud_ques_ans_list[++this.que_index];
      this.select_opt = this.current_ques.selectedoption_obj;
    },
    getPrevious() {
      this.current_ques = this.stud_ques_ans_list[--this.que_index];
      this.select_opt = this.current_ques.selectedoption_obj;
    },
    startCallBack: function (x) {
      // console.log(x);
    },
    endCallBack: function (x) {
      // console.log(x);
      this.exitExam("");
      //alert(x)
    },

    getSubQues() {},
    go_full_screen() {
      var elem = document.documentElement;
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      }
    },
    zooimg(url_img) {
      this.img_url = url_img;
      this.dialog_zooimg = true;
    },
    startTimer() {
      console.log("focus");
      this.endexamflag = false;
      //myInterval = window.setInterval(timerHandler, 1000);
    },

    // Stop timer
    stopTimer() {
      console.log("change");
      if (!this.endexamflag) {
        if(this.TAB_SWITCHING == 'NO'){
        this.tbsnackbar = true;
        this.tabSwitchCount = this.tabSwitchCount + 1
        }

        this.timeout = 0;
      }
      // window.clearInterval(myInterval);
    },
  },

  mounted() {
    //by vrushali
    this.show_whitebord = this.$route.params.show_whitebord;
    this.TAB_SWITCHING = this.$route.params.TAB_SWITCHING;
this.tabSwitchPermission();
    //end vrushali code
    this.deviceWidth = window.innerWidth;
    this.endexamflag = false;
    this.deviceHeight = window.innerHeight - 160;
    this.snack_height = this.deviceHeight / 2;

    if (this.deviceWidth > 600) {
      this.logWidth = "1000";
    }
    if (this.deviceWidth < 600) {
      this.logWidth = "1000";
    }

    document.addEventListener("contextmenu", (event) => event.preventDefault());
    // document.onkeydown = function (e) {
    //     return false;
    // };
    if (localStorage.getItem("stud_ques_ans_list") == "") {
      this.$router.push({
        name: "stud-start-exam",
      });
      return;
    }
    this.stud_ques_ans_list = JSON.parse(
      localStorage.getItem("stud_ques_ans_list")
    );
    this.supervisionlink = JSON.parse(localStorage.getItem("supervisionlink"));

    this.meetingLink = this.supervisionlink.supervisionlink;
    if (this.supervisionlink.isEnable && !this.supervisionlink.isClicked) {
      this.meetingBox = true;
    }

    this.les = JSON.parse(localStorage.getItem("les"));
    this.chat_data = {
      les_id: this.les.les_id,
      flag: true,
    };
    if (this.les.end_timer != null) {
      this.totalsec = this.les.end_timer;
      //   console.log("b4 start:" + this.totalsec);
      // if(this.totalsec==0)
      //     this.totalsec=60
      if (this.totalsec > 0) {
        this.tim = setInterval(() => {
          this.showtime();
        }, 1000);
      }
    }
    this.ans_status = JSON.parse(localStorage.getItem("ans_status"));
    this.invalidQuestionCheck = JSON.parse(localStorage.getItem("invalidQuestionCheck"));
    this.current_ques = this.stud_ques_ans_list[0];
    this.select_opt = this.current_ques.selectedoption_obj;
    //console.log(this.stud_ques_ans_list);
    //this.go_full_screen()
    window.addEventListener("focus", this.startTimer);

    // Inactive

    window.addEventListener("blur", this.stopTimer);

    // Start timer

  },

  
};
</script>

<style scoped>
.log-t {
  background: linear-gradient(
    130deg,
    hsla(190, 99%, 30%, 1) 0%,
    hsla(226, 50%, 65%, 1) 180%
  );
  color: white;
  padding: 0 !important;
}
.log-flex {
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  font-size: 20px;
  color: white;
}
.tab-msg {
  padding: 2rem !important;
  font-size: 20px;
}
.timer-m {
  display: flex;
}
.chat-icon {
  bottom: 0px;
  right: 0px;
  position: fixed !important;

  z-index: 1;
  cursor: pointer;
}
.meet-box {
  border: 2px solid #607d8b;
  border-radius: 5px;
  padding: 0.5rem;
}
.meet {
  border: 4px solid red;
}
.blink_me {
  white-space: nowrap;
  color: red;
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
.status {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 20px;
  margin-top: 0.4rem;
}
.v-chip.v-size--default {
  border-radius: 0px !important;
}
.pat {
  padding: 17px 46px 17px 46px;
}
.end-exam {
  background: red !important;
  color: white;
  font-weight: bold;
  font-size: 16px;
}
.timer {
  margin-right: 5px !important;
  color: red;
  font-weight: bold;
  background: #f5f5f5;
  margin: -6px 0px 7px 0px;
  /* border-radius: 30px; */
  padding: 4px 6px 4px 6px;
}

.borderes {
  /* border: 1px solid #ff9800;
    background:#ff9800;
    margin: -6px 0px 7px 0px;
    border-radius: 30px;
    padding: 4px 20px 4px 20px; */
  font-size: 16px;
  color: white;
  font-weight: bold;
}

.opt {
  background: #607d8b;
  border: 4px solid #a4edf1;
  border-radius: 30px;
  color: white;
  font-size: 16px;
  font-weight: bold;
  margin-top: 0.3%;
  height: 2rem;
  width: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.opt-radio {
  height: 3rem;
  width: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 !important;
}

.opt-label {
  margin: 0;
}

p {
  display: none !important;
}

.question-block {
  /* border: 1.7px solid #424093; */
  margin: 1rem;
  padding-left: 22px;
  border-radius: 6px;
}

.que-display {
  /* background: #00E5FF !important; */
  background: #add8e666;
  color: white !important;
  padding: 0.8rem !important;
  /* border: 3px solid #607d8b; */
}

.que-tag {
  color: #607d8b !important;
  font-size: 18px;
  font-weight: bold;
}

.pt {
  padding-top: 70px;
  background: white;
}

.heading {
  background: #607d8b !important;
}

.sub {
  font-size: 20px;
  font-weight: bold;
}

.main-h {
  display: flex;
  justify-content: space-between;
  padding: 0rem 1rem 0rem 1rem;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1;
  background: linear-gradient(
    130deg,
    hsla(190, 99%, 30%, 1) 0%,
    hsla(226, 50%, 65%, 1) 180%
  );
}

.que {
  /* height: 450px; */
  overflow-y: auto;
}

#style-3::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

#style-3::-webkit-scrollbar {
  width: 4px;
  background-color: #f5f5f5;
}

#style-3::-webkit-scrollbar-thumb {
  background-color: #607d8b !important;
}

.ans-img {
  width: auto;
  height: 40px;
}

.time {
  float: right;
  color: #a4edf1;
  font-size: 18px;
  font-weight: bold;
}

.stu-btn {
  width: 40%;
  cursor: none;
  color: white;
  font-weight: bold;
}

.nav-btn {
  text-align: center;
  padding: 10px;
}

.sub-btn {
  color: white;
  min-width: 10rem !important;
  background: #00e5ff !important;
  font-weight: 500;
  margin: 1rem;
  min-height: 2.5rem;
}
.save-btn {
  color: white;
  min-width: 10rem !important;
  background: green !important;
  font-weight: 500;
  margin: 1rem;
  min-height: 2.5rem;
}
.review-btn {
  color: white;
  min-width: 10rem !important;
  background: blue !important;
  font-weight: 500;
  margin: 1rem;
  min-height: 2.5rem;
}
.next-btn {
  color: white;
  min-width: 10rem !important;
  background: #607d8b !important;
  font-weight: 500;
  margin: 1rem;
  min-height: 2.5rem;
}
.q-img {
  width: 550px;
  height: auto;
}

.new5 {
  border: 2px solid #049bc9;
}

@media only screen and (max-width: 600px) {
  .main-h {
    display: block;
    justify-content: space-between;
    padding: 1rem;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1;
    background: linear-gradient(
      130deg,
      hsla(190, 99%, 30%, 1) 0%,
      hsla(226, 50%, 65%, 1) 180%
    );
  }

  .row-card {
    margin-top: 10px !important;
    /* display:flex */
  }
  .sub {
    font-size: 15px;
    font-weight: bold;
  }

  .pt {
    background: white;
    padding-top: 120px;
  }

  .sm-pd {
    padding-left: 7px;
  }

  .sub-btn {
    margin: 0.5rem;
  }

  .borderes {
    /* border: 1px solid #ff9800;
    background:#ff9800;
    margin: -6px 0px 7px 0px;
    border-radius: 30px;
    padding: 4px 20px 4px 20px; */
    font-size: 16px;
    color: black;
    font-weight: bold;
    text-align: center;
  }
  .timer-m {
    display: flex;
    justify-content: center;
  }
}

.padding-options {
  padding-left: 62px;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.home-icon {
  color: white;
  margin-top: -5px;
}

.home-text {
  color: white;
  margin-top: 3px !important;
  font-size: 16px;
  font-weight: bold;
}

.card-ques {
  /* padding-left: 13px !important; */
  overflow: scroll;
}

.row-card {
  margin-top: -8px;
  /* display:flex */
}

.question-text {
  padding: 0px !important;
  margin-left: 19px;
  font-weight: bold;
}

.options-text {
  font-size: 20px;
  padding-left: 6px;
  margin-left: 1rem;
}

.padding-zero {
  padding: 0px !important;
}
.padding {
  padding: 0.3rem;
}
.padding-top-zero {
  padding-top: 0px !important;
}

.option-val {
  opacity: 1;
  margin-top: 10px;
  padding-left: 7px;
}

.overview-row {
  padding: 0px;
  padding-top: 12px;
}

.overview-card {
  /* height: 504px; */
  overflow-y: scroll;
}

.overview-card::-webkit-scrollbar-thumb {
  background-color: #607d8b !important;
}
.imgs {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 4px;
  width: 750px;
  cursor: zoom-in;
}
.imgs-question {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 4px;
  /* width: 750px; */
  cursor: zoom-in;
  width: 15rem;
  margin-top: 10px;
}
.imgs-options {
  /* border: 1px solid #ddd; */
  border-radius: 4px;
  padding: 5px;
  width: auto;
  height: 50px;
  cursor: zoom-in;
}

.imgs-preview {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  width: 80%;
}
.whiteboard {
  color: white !important;
}
.d-f{
  display: flex;
  justify-content: space-between;
}

.v-input{
  margin: 0px;
}

</style>
